import { MATHLETICS_ID } from '../../../../helpers/constants';
import { localeCode } from '../../../../helpers/locale-helpers';
import Resources from '../../../../helpers/resources';
import dropdownDataActions from '../../redux/dropdown-data/dropdown-data-actions';

export const YEAR_GROUPS_RETRIEVED = 'YEAR_GROUPS_RETRIEVED';

function getYearGroups() {
    const locale = localeCode();
    return (dispatch) =>
        Resources.yearGroups
            .get()
            .withParams({
                productId: MATHLETICS_ID,
                locale
            })
            .send()
            .then((payload) => {
                dispatch({
                    type: YEAR_GROUPS_RETRIEVED,
                    payload: payload.data
                });
                dispatch(dropdownDataActions.setYearGroups(payload.data));
            });
}

export default {
    getYearGroups
};



// WEBPACK FOOTER //
// ./components/report-filters/redux/year-groups/year-groups-actions.js